<style lang="scss">
  @import '../resources/scss/new_thumbnail.scss';
</style>

<script lang="ts">
  import { locale } from 'svelte-i18n'
  import { getFormattedDate } from '../helpers/NewThumbnail'
  export let publicationDate: string | undefined
  let lang = $locale ?? String(process.env.LOCALE)
  let formattedDate = publicationDate ? getFormattedDate(publicationDate, lang) : null
</script>

<div class="new-thumbnail-project-info-container d-flex">
  {#if formattedDate}
    <div class="body-2 text-neutral-b">{formattedDate}</div>
  {/if}
</div>
